/**
 * Thin wrapper around portal's EnhancedProtectedRoute that consumes the
 * adminRbacMatrix instead of taking ad-hoc props per call site. Every admin
 * route uses this — keeps gating consistent and changes Phase K's SALES role
 * addition to a single-line edit in adminRbacMatrix.ts.
 */

import React from 'react';
import { EnhancedProtectedRoute } from '@vehix/portal/features/auth/components/EnhancedProtectedRoute';
import { gateFor, type AdminPage } from '../lib/adminRbacMatrix';

interface AdminProtectedRouteProps {
  page: AdminPage;
  children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ page, children }) => {
  const { requiredSystemRoles } = gateFor(page);
  return (
    <EnhancedProtectedRoute requiredSystemRoles={requiredSystemRoles}>
      {children}
    </EnhancedProtectedRoute>
  );
};
